<template>
	<ul>
		<li v-for="item in data" :key="item.id" @click="toCs(item)">
			<van-image class="bg" :src="item.cover || defaultImg" alt="" />
			<div class="info">
				<p class="nickname">
					{{ item.name }}
				</p>
				<p class="desc">{{ item.description }}</p>
			</div>
		</li>
	</ul>
</template>

<script setup>
import defaultImg from "~/assets/images/default.png";
import { goLink } from "~/utils/common";
import { logEvent } from "~/utils/firebase";

const props = defineProps({
	data: {
		type: Array,
		default: () => [],
	},
	teacherId: {
		type: String,
		default: "",
	},
	csEvent: {
		type: String,
		default: "",
	},
	schannel: {
		type: String,
		default: "",
	},
});

const toCs = item => {
	logEvent(props.csEvent);
	goLink(item.jump_url, props.schannel);
};
</script>

<style lang="scss" scoped>
ul {
	padding: 32px 32px 0;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	font-family: PingFang SC;

	li {
		width: 334px;
		margin-bottom: 16px;
		display: flex;
		flex-direction: column;
		align-items: center;
		background-color: #ffffff;
		border-radius: 8px;
		cursor: pointer;
		overflow: hidden;

		&:nth-last-child(1),
		&:nth-last-child(2) {
			margin-bottom: 0;
		}

		&:nth-child(2n) {
			margin-right: 0;
		}

		.bg {
			width: 334px;
			height: 334px;
			object-fit: cover;
		}

		.info {
			flex: 1;
			display: flex;
			flex-direction: column;
			align-items: center;
			padding: 16px;

			.nickname {
				width: 100%;
				font-weight: 500;
				font-size: 32px;
				color: #2b2f36;
				line-height: 38px;
			}

			.desc {
				margin-top: 8px;
				font-size: 26px;
				color: #646a73;
				line-height: 34px;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				overflow: hidden;
				text-overflow: ellipsis;
			}
		}
	}
}
</style>
